<template>
  <div>
    <b-card
      :style="'background: #DBF9F6'"
      class="border-0 card-border-radius"
    >
      <b-button
        v-if="!isView"
        class="btn-custom px-5"
        variant="info"
        size="sm"
        @click="addRowOtherDeduction"
      >
        Add
      </b-button>
      <b-card
        class="border-0 card-border-radius mt-3"
        v-for="(item, index) in form.bup_others_other_deduction"
        :key="index"
      >
        <b-row>
          <b-col
            cols="1"
            class="d-flex align-items-center justify-content-center"
            v-if="!isView"
          >
            <img
              src="@/assets/icon-trash.png"
              width="25"
              height="25"
              style="cursor: pointer"
              @click="removeOtherDeduction(index)"
            >
          </b-col>
          <b-col>
            <validation-provider
              name="Description Other Deduction"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill mb-2"
            >
              <b-form-group
                label="Description"
                label-size="sm"
                label-class="font-weight-bold"
                :invalid-feedback="errors[0]"
              >
                <b-form-input
                  v-model="item.description"
                  autocapitalize="off"
                  placeholder="Enter Description"
                  size="sm"
                  :class="{ 'is-invalid': errors.length }"
                  :invalid-feedback="errors[0]"
                  :disabled="isView"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
              name="Qty Other Deduction"
              rules="required|min_value:1"
              v-slot="{ errors }"
              slim
              class="flex-fill mb-2"
            >
              <b-form-group
                label="Qty"
                label-size="sm"
                label-class="font-weight-bold"
                :invalid-feedback="errors[0]"
              >
                <b-form-input
                  v-model="item.qty"
                  autocapitalize="off"
                  placeholder="Enter Qty"
                  type="number"
                  size="sm"
                  :class="{ 'is-invalid': errors.length }"
                  :invalid-feedback="errors[0]"
                  :disabled="isView"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
              name="Amount Other Deduction"
              rules="required|min_value:1"
              v-slot="{ errors }"
              slim
              class="flex-fill mb-2"
            >
              <b-form-group
                label="Amount (IDR)"
                label-size="sm"
                label-class="font-weight-bold"
                :invalid-feedback="errors[0]"
                :disabled="isView"
              >
                <b-form-input
                  v-model="item.amount"
                  autocapitalize="off"
                  placeholder="Enter Amount"
                  type="number"
                  size="sm"
                  :class="{ 'is-invalid': errors.length }"
                  :invalid-feedback="errors[0]"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <b-form-group
                label="Sub Total"
                label-size="sm"
                label-class="font-weight-bold"
                :disabled="isView"
              >
                <b-form-input
                  :value="item.qty * item.amount"
                  autocapitalize="off"
                  placeholder="Enter Amount"
                  type="number"
                  size="sm"
                  disabled
                />
              </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <div class="mt-3 w-100 d-flex justify-content-between font-weight-bold">
        <div class="ml-5">Total</div>
        <div class="mr-5">{{ formatMoney(subTotal(form.bup_others_other_deduction), { symbol: '', precision: '2', thousand: ',' }) }}</div>
      </div>
    </b-card>
    <br>

    <h6 class="font-weight-bold">Attachment Supporting Document</h6>
    <div v-if="!isView" class="mt-4">
      <div>
        <div class="dropbox">
          <input
            type="file"
            @change="onChangeFile($event.target.files)"
            class="input-file"
            multiple
            accept=".xls, .xlsx, .doc, .docx, .pdf"
          >
            <img
              class="mt-2"
              src="@/assets/icon-upload.png"
              width="100"
              height="100"
            >
            <div>
              <p id="text-dropbox">Drag or klik button to upload file</p>
            </div>
            <b-button
              class="btn-custom"
              variant="info"
              size="sm"
            >
              Browse File
            </b-button>
        </div>
      </div>
    </div>
    <div
      v-if="attachmentOtherDeduction.length"
      :style="gridStyle"
      class="card-list mt-2 p-0"
      id="attachment"
    >
      <div
        v-for="(item, index) in attachmentOtherDeduction"
        :key="index"
        class="supporting-file"
      >
      <div
          class="dropbox-files mx-1 mb-2"
        >
          <div
            v-if="item.file_name"
            class="background-file"
          >
            <div class="d-flex justify-content-end">
              <img
                v-if="!isView"
                class="mr-2 mt-2"
                src="@/assets/icon-trash.png"
                width="25"
                height="25"
                style="cursor: pointer"
                @click="removeFile(index, item.id)"
              >
            </div>
            <div class="pointer" @click="downloadFile(item)">
              <img
                v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-excel.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[4]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-pdf.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-word.png"
                width="70"
                height="70"
              >
            </div>
          </div>
          <div
            class="text mt-2"
          >
            <span class="text-ellipsis mx-2">{{ item ? item.file_name : 'NaN'}}</span>
            <span class="size-file">{{ item ? item.size : 'NaN mb'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isView && !attachmentOtherDeduction.length" class="w-100 text-center">No Attachment</div>
  </div>
</template>

<script>
import api from '@/api'
import { formatMoney } from 'accounting-js'

export default {
  props: {
    isView: {
      types: Boolean,
      default: false
    },
    isEdit: {
      types: Boolean,
      default: false
    },
    form: {
      types: Object,
      default: () => {}
    }
  },

  components: {},

  data: () => ({
    numberOfColumns: 4,
    attachmentOtherDeduction: [],
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    isUpload: false,
    upload: {
      progress: 0,
      variant: 'success'
    }
  }),

  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.fetchAttachment()
    }
  },

  methods: {
    formatMoney,
    async fetchAttachment() {
      this.attachmentOtherDeduction = await api.other.getAttachment(this.$route.params.id, 'Other Deduction')
    },
    addRowOtherDeduction() {
      this.form.bup_others_other_deduction.push({
        description: '',
        qty: '',
        amount: ''
      })
    },
    removeOtherDeduction(index) {
      this.form.bup_others_other_deduction = [
        ...this.form.bup_others_other_deduction.slice(0, index),
        ...this.form.bup_others_other_deduction.slice(index + 1)
      ]
    },
    async onChangeFile(value) {
      let isTypeAllowed = true
      let isSizeAllowed = true
      if (value.length + this.attachmentOtherDeduction.length > 10) {
        this.$nextTick(() => {
          this.$bvToast.toast('maximum file to upload only 10 files', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
        return
      }
      const formData = new FormData()
      for (let i = 0; i < value.length; i++) {
        const nameFile = value[i].name.split('.')
        if ((this.attachmentType.includes(nameFile[nameFile.length - 1]))) {
          if (value[i].size < 3072000) {
            formData.append('bup_others_file', value[i])
          } else {
            isSizeAllowed = false
            break
          }
        } else {
          isTypeAllowed = false
          break
        }
      }
      if (!isTypeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Only PDF, Excel and Doc files are allowed.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }

      if (!isSizeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Max size file 3 mb.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      if (isTypeAllowed && isSizeAllowed) {
        await this.uploadAttachment(formData, value)
      }
    },
    async uploadAttachment(formData, value) {
      try {
        const data = await api.other
          .uploadAttachment(
            this.$route.params.id ? this.$route.params.id : 0,
            'Other Deduction',
            formData,
            { onUploadProgress: this.setUploadProgress }
          )
        if (!this.$route.params.id) {
          data[0].map(v => {
            this.form.attachmentOtherDeductionId.push(v)
          })
          for (const file of Object.entries(value)) {
            this.attachmentOtherDeduction.push({
              file_name: file[1].name,
              size: this.formatBytes(file[1].size),
              url: file[1],
              id: null
            })
          }
          this.form.attachmentOtherDeductionId.map((v, i) => {
            this.attachmentOtherDeduction[i].id = v
          })
        } else {
          setTimeout(() => this.fetchAttachment(), 1500)
        }
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    setUploadProgress({ loaded }) {
      this.upload.progress = loaded
    },
    checkType(fileName) {
      const splitFileName = fileName.split('.')
      return splitFileName[splitFileName.length - 1]
    },
    async removeFile(index, fileId) {
      try {
        this.attachmentOtherDeduction.splice(index, 1)
        this.form.attachmentOtherDeductionId.splice(index, 1)
        await api.other.deleteAttachment(fileId)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    downloadFile(item) {
      window.open(item.url)
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    subTotal(item) {
      let x = 0
      item.map(v => {
        if (v.qty) {
          x += v.qty * (parseFloat(v.amount) || 0)
        }
      })
      return x
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
